// removed by extract-text-webpack-plugin
module.exports = {"overlay-drop-shadow":"overlay-drop-shadow-8168bf","sapcnqr-overlay":"sapcnqr-overlay-c249df","sapcnqr-overlay__content":"sapcnqr-overlay__content-ce5bec"};